<template>
  <div>
    <h1>Team assign</h1>
    <FileWorking :file="file" />
    <v-alert :value="true" type="info"
      >Select the team from the list below. The current team is already
      highlighted. Then click save to update and return to the file.</v-alert
    >
    <v-select
      label="Team"
      v-model="teamid"
      :items="teams"
      item-value="id"
      item-text="name"
      outline
    />
    <v-btn @click="save"> <v-icon>save</v-icon>Save </v-btn>
    <v-alert :value="alertError" type="error">{{ alertError }}</v-alert>
    <h2>History</h2>
    <v-data-table
      v-if="computedFileTeams"
      :headers="headers"
      :items="computedFileTeams"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <!-- <td>{{props.item.fileid}}</td> -->
          <td>
            <router-link
              :to="{ name: 'team', params: { id: props.item.team.id } }"
              v-if="props.item.team"
              >{{
                `${props.item.team.code} - ${props.item.team.name}`
              }}</router-link
            >
            <span v-if="!props.item.team">{{ props.item.teamid }}</span>
          </td>
          <td>
            {{ props.item.archived | formatDateTime }}
            <a
              v-if="
                props.item.archived && $keycloak.hasRealmRole('directoryadmin')
              "
              @click="archiveFileTeam(props.item, false)"
              >unarchive</a
            >
            <a
              v-if="
                !props.item.archived && $keycloak.hasRealmRole('directoryadmin')
              "
              @click="archiveFileTeam(props.item, true)"
              >archive</a
            >
          </td>
          <td>
            <EntityZ
              :entity="props.item.user"
              format="system"
              v-if="props.item.user"
            />
            <span v-if="!props.item.user">{{ props.item.userid }}</span>
          </td>
          <td>{{ props.item.created | formatDateTime }}</td>
          <td>
            <a
              v-if="$keycloak.hasRealmRole('directoryadmin')"
              @click="deleteFileTeam(props.item)"
              >delete</a
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TEAMS from "@/graphql/directory/Teams";
import nbmlaw from "@/api/nbmlaw";
import EntityZ from "@/components/link/EntityZ";
import FileWorking from "@/components/link/FileWorking";
export default {
  name: "TeamAssign",
  metaInfo() {
    return {
      title: "Team assign",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ,
    FileWorking
  },
  apollo: {
    teams: {
      query: TEAMS,
      variables: { archived: false },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    computedFileTeams() {
      if (!this.fileTeams) {
        return undefined;
      }
      return this.fileTeams.map((f) => {
        const team = this.fileTeamsTeams
          ? this.fileTeamsTeams[f.teamid]
          : undefined;
        const user = this.fileTeamsUsers
          ? this.fileTeamsUsers[f.userid]
          : undefined;
        return { ...f, team, user };
      });
    }
  },
  data() {
    return {
      file: null,
      fileTeams: null,
      fileTeamsTeams: null,
      fileTeamsUsers: null,
      fileTeam: null,
      teamid: null,
      alertError: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        // {
        //   text: "File",
        //   value: "fileid"
        // },
        {
          text: "Team",
          value: "teamid"
        },
        {
          text: "Archived",
          value: "archived"
        },
        {
          text: "User",
          value: "userid"
        },
        {
          text: "Created",
          value: "created"
        },
        {
          text: " ",
          sortable: false
        }
      ]
    };
  },
  methods: {
    async fetchFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}`
      );
      // console.log(response.data);
      this.file = response.data;
    },
    async fetchFileTeams() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}/fileTeams`
      );
      // console.log(response.data);
      this.fileTeams = response.data;
    },
    async fetchFileTeamsTeams() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}/fileTeams/teams`
      );
      // console.log(response.data);
      this.fileTeamsTeams = response.data;
    },
    async fetchFileTeamsUsers() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}/fileTeams/users`
      );
      // console.log(response.data);
      this.fileTeamsUsers = response.data;
    },
    async save() {
      try {
        await nbmlaw.post(
          `/cors/admin/file/files/${this.$route.params.objectId}/fileTeams/${this.teamid}`,
          null
        );
        // console.log(response.data);
        this.$router.push({
          name: "file",
          params: { id: this.$route.params.objectId }
        });
      } catch (error) {
        this.alertError = error.response.data;
      }
    },
    async archiveFileTeam(fileTeam, value) {
      await nbmlaw.put(
        `/cors/admin/directory/fileTeams/${fileTeam.id}/archive/${value}`,
        null
      );
      // console.log(response.data);
      this.update();
    },
    async deleteFileTeam(fileTeam) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/directory/fileTeams/${fileTeam.id}`);
        // console.log(response.data);
        this.update();
      }
    },
    update() {
      this.fetchFile();
      this.fetchFileTeams();
      this.fetchFileTeamsTeams();
      this.fetchFileTeamsUsers();
    }
  },
  watch: {
    "$route.params.objectId": {
      immediate: true,
      handler() {
        this.update();
      }
    },
    fileTeams: {
      handler() {
        const fileTeamsActive = this.fileTeams.filter((t) => !t.archived);
        if (fileTeamsActive.length == 1) {
          this.fileTeam = fileTeamsActive[0];
          this.teamid = this.fileTeam.teamid;
        } else if (fileTeamsActive.length > 1) {
          //error
        } else {
          this.fileTeam = null;
          this.teamid = null;
        }
      }
    }
  }
};
</script>
